import { createListViewComponent } from 'factories/ListView'
import entityNames from 'options/entityNames'
import Filter from 'containers/Reports/LocationCountStockOutReport/Filter'
import { formatValue } from 'helpers/listViews'

export default createListViewComponent({
  entityName: entityNames.locationCountStockOutReport,
  filterTemplateType: 'locationCountStockOutReport',
  initialFilterDto: (self) => ({ dateRange: { dateRangeType: 'YearToDate' } }),
  allowCreate: (self) => false,
  allowSelection: (self) => false,
  tableCellComponents: {
    createDate: (self, record) => {
      const reportGrouping = self.state.filterDto?.reportGrouping ?? 'None'

      if (reportGrouping === 'None') {
        return formatValue({ value: record.createDate, displayFormat: 'DateTime', dtoFieldName: 'createDate' })
      }

      if (reportGrouping === 'CreateDate') {
        return formatValue({ value: record.createDate, displayFormat: 'Date', dtoFieldName: 'createDate' })
      }

      return '---'
    },
  },
})(Filter)
